import type {
    SignalManagementBaseProps,
} from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalManagementBase/SignalManagementBase";
import SignalManagementBase from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalManagementBase/SignalManagementBase";
import type { Translatable } from "app/pages/sales-intelligence/types";

import type ModifySignalViewModel from "../../../models/view/signal-modal/ModifySignalViewModel";
import ModalHeaderContent from "../SignalsModal/ModalHeaderContent/ModalHeaderContent";
import { DESCRIPTION_TRANSLATABLE } from "./const";

export type EditSignalModalProps = Omit<SignalManagementBaseProps, "headerContent"> & {
    viewModel: Readonly<ModifySignalViewModel>;
};
const EditSignalModal = (props: EditSignalModalProps) => {
    const { children, isOpen, viewModel, onReturn, onClose } = props;

    const selectedSignalType = viewModel.initiallySelectedType;
    const titleTranslatable: Readonly<Translatable> = {
        key: `si.signals.type.${selectedSignalType}.edit-signal.text`,
    };

    return (
        <SignalManagementBase
            isOpen={isOpen}
            headerContent={
                <ModalHeaderContent
                    title={titleTranslatable}
                    description={DESCRIPTION_TRANSLATABLE}
                />
            }
            onReturn={onReturn}
            onClose={onClose}
        >
            {children}
        </SignalManagementBase>
    );
}

export default EditSignalModal;
